import { render, staticRenderFns } from "./ResourceChart.vue?vue&type=template&id=d0c13c76&scoped=true&"
import script from "./ResourceChart.vue?vue&type=script&lang=ts&"
export * from "./ResourceChart.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceChart.vue?vue&type=style&index=0&id=d0c13c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c13c76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTooltip})
